import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notifications } from '@mantine/notifications';
import { useTranslation } from 'react-i18next';
import { HealthcareProfessionalsApi } from '../../../apis/HealthcareProfessionalsApi/HealthcareProfessionalsApi.ts';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { AppMedError } from '../../../error/AppMedError.ts';
import { IHcpReenrollment } from '../HealthcareProfessional.ts';

export function useReenrollHcp() {
    const queryClient = useQueryClient();
    const { t } = useTranslation();

    return useMutation<void, AppMedError, { healthcareProfessionalId: number; reenrollment: IHcpReenrollment }>({
        mutationFn: async ({ healthcareProfessionalId, reenrollment }) =>
            HealthcareProfessionalsApi.reenroll(healthcareProfessionalId.toString(), reenrollment),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [QueryKeys.healthcareProfessionals] });
            notifications.show({ message: t('hcp.reenrollDone'), color: 'green' });
        },
    });
}
